module.exports = __webpack_public_path__ + "static/img/after-market-status.b9a97a49.png";